export default __webpack_public_path__ + "static/btclassic-windows-screen@2x-7aa9a7e45da59a5978db8aebd1bc3ee2.jpg";